<template>
  <div>
    <div v-if="message.name" class="document-message">
      <b-icon
        class="document-message__icon"
        icon="file-document"
        type="is-success"
      ></b-icon>
      <p class="doc-title" :title="message.name">
        {{ message.name }}
        <br />
        <b v-if="message.docType && message.docType.length">
          {{ message.docType }}
        </b>
      </p>
      <p v-if="message.updatedAt" class="small doc-title">
        Last Modified: {{ message.updatedTime }}
      </p>
      <br v-if="message.message" />
      <p v-if="message.createdAt" class="small doc-title">
        First uploaded: {{ message.createdTime }}
      </p>
      <p v-if="message.uploader_name" class="small doc-title">
        Uploaded by: {{ message.uploader_name }}
      </p>
      <b-button
        type="is-link"
        class="document-message__download"
        @click="downloadItem(message)"
        icon-left="download"
      ></b-button>
    </div>
    <div v-else :class="{ right: isRight, left: !isRight, bubble: true }">
      {{ message.message }}
      <div class="seen-message">
        <span class="message-sender">
          Sent by: {{ moderatorName }}, {{ convertedMessageTime }}
        </span>
        <b-icon
          :title="!message.isUnread ? 'Seen message' : 'Message not yet seen'"
          style="cursor: pointer"
          icon="check-all"
          :type="message.isUnread ? 'is-danger' : 'is-success'"
          size="is-small"
          @click.native.prevent="toggleMessageSeen(message)"
        ></b-icon>
      </div>
    </div>
  </div>
</template>

<script>
import UtilService from '../../services/util';
import downloadBlob from '../../services/file-download';
import StudentService from '../../services/student.service';

import moment from 'moment';
export default {
  name: 'bubble',
  props: ['message'],
  computed: {
    getActiveConversation() {
      return UtilService.getActiveConversation();
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    isManagement() {
      return UtilService.isManagement();
    },
    isManager() {
      return UtilService.isManager();
    },
    isRight() {
      return this.message.moderatorId === this.currentUser.id;
    },
    convertedMessageTime() {
      return moment(this.message.createdAt).format('LLL');
    },
    moderatorName() {
      if (this.message.moderatorName) {
        return this.message.moderatorName;
      }

      const foundUser = this.$store.state.users.users.filter(
        (user) => user.id === this.message.moderatorId
      );
      if (foundUser && foundUser.length) {
        return foundUser[0].username;
      }

      return 'Invalid username';
    },
  },
  methods: {
    async downloadItem(message) {
      const url = message.path.replace('dist', '');
      const download = message.name;
      downloadBlob(url, download);
    },

    toggleMessageSeen(message) {
      if (!message.isUnread && (this.isManagement || this.isManager)) {
        StudentService.markMessageAsUnseen({
          id: message.id,
        }).then(() => {
          this.$buefy.toast.open({
            duration: 3000,
            message: `Message marked as unseen`,
            position: 'is-bottom',
            type: 'is-success',
          });

          this.$eventHub.$emit('socket__event', {
            messageType: 'socket__edit-message',
            messageValue: {
              ids: [message.id],
              isUnread: true,
            },
          });
        });
      }
    },
  },
};
</script>

<style>
.bubble {
  position: relative;
  max-width: 100%;
  padding: 4px 12px;
  background: rgb(10, 124, 255);
  color: #fff;
  border-radius: 8px;
}

.document-message {
  box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
  width: 100%;
  padding: 8px;
  border-radius: 8px;
}

.document-message__icon {
  position: absolute;
  top: 0;
  left: -10px;
}

.left {
  --_d: 0%;
  color: #000;
  background: #e1e5ec;
}

.right {
  --_d: 100%;
}

.seen-message {
  right: 0;
  bottom: 4px;
}

.left .seen-message {
  left: 32px;
}

.left .message-sender {
  color: #000;
}

.message-sender {
  color: #fff;
  font-weight: bold;
  font-size: 12px;
}

.action-icon {
  position: absolute;
  background: white;
  border-radius: 50%;
  box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
}

.action-icon__complete {
  top: -10px;
  left: -10px;
}

.action-icon__delete {
  bottom: -10px;
  left: -10px;
}

.left .action-icon__complete,
.left .action-icon__delete {
  right: -10px;
  left: auto;
}

button.document-message__download {
  left: -12px;
  bottom: -22px;
}
</style>
